/* Bandeau de consentement — habillage Manga Horizon (02/09/2026)
   Réécrit le titre et le texte du bandeau natif, et insère le bandeau de tête
   (lignes de vitesse + onigiri) devant le contenu. Tout le reste est intact :
   les trois boutons, le lien vers la politique, la mécanique de consentement.
   Si Shopify change sa structure, le script ne trouve rien et ne fait rien. */
(function () {
  'use strict';

  // version anglaise (16/09/2026) : textes selon la langue de la page (<html lang>)
  var EN = (document.documentElement.lang || 'fr').slice(0, 2) !== 'fr';
  var TITRE = EN ? 'Level 1: cookies' : 'Niveau 1 : les cookies';
  var TEXTE = EN
    ? 'Improve the site, measure what people like, personalize our ads. ' +
      'You choose, and we let you get back to your adventure. '
    : 'Améliorer le site, mesurer ce qui plaît, personnaliser nos pubs. ' +
      'Tu choisis, et on te laisse repartir à l’aventure. ';
  var LIEN = EN ? 'Details' : 'Détails';
  var REPLI = EN ? '/en/policies/privacy-policy' : '/policies/privacy-policy';

  function habiller() {
    var d = document.getElementById('shopify-pc__banner');
    if (!d || d.getAttribute('data-mh') === '1') return;

    var titre = d.querySelector('#shopify-pc__banner__body-title');
    var para = d.querySelector('.shopify-pc__banner__body p');
    var wrap = d.querySelector('.shopify-pc__banner__wrapper');
    if (!titre || !para || !wrap) return;

    titre.textContent = TITRE;

    // on conserve l'adresse réelle de la politique de confidentialité
    var ancien = para.querySelector('a');
    var url = ancien ? ancien.getAttribute('href') : REPLI;
    para.textContent = TEXTE;
    var lien = document.createElement('a');
    lien.id = 'shopify-pc__banner__body-policy-link';
    lien.href = url;
    lien.target = '_blank';
    lien.rel = 'noopener noreferrer';
    lien.textContent = LIEN;
    para.appendChild(lien);

    // bandeau de tête : le titre y est déplacé, son id ne bouge pas donc
    // aria-labelledby continue de pointer dessus
    var band = document.createElement('div');
    band.className = 'mh-band';
    var oni = document.createElement('span');
    oni.className = 'mh-onigiri';
    oni.setAttribute('aria-hidden', 'true');
    band.appendChild(oni);
    band.appendChild(titre);
    d.insertBefore(band, wrap);

    d.setAttribute('data-mh', '1');
  }

  function surveiller() {
    habiller();
    if (!window.MutationObserver || !document.body) return;
    // childList sur le body seulement : le bandeau y est ajouté à la racine,
    // et le panneau de préférences peut le recréer
    new MutationObserver(habiller).observe(document.body, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', surveiller);
  } else {
    surveiller();
  }
  window.addEventListener('load', habiller);
})();
